import React from 'react';
import * as LucideIcons from 'lucide-react';

/**
 * Icon Component - Wrapper for Lucide icons with consistent sizing
 * @param {Object} props
 * @param {string} props.name - Lucide icon name (e.g., 'Home', 'User', 'Settings')
 * @param {number} props.size - Icon size in pixels (default: 20)
 * @param {string} props.color - Icon color (default: currentColor)
 * @param {string} props.className - Additional CSS classes
 * @param {Object} props.style - Additional inline styles
 * @param {Function} props.onClick - Click handler
 */
function Icon({
  name,
  size = 20,
  color = 'currentColor',
  className = '',
  style = {},
  onClick,
}) {
  const IconComponent = LucideIcons[name];

  if (!IconComponent) {
    console.warn(`Icon "${name}" not found in Lucide icons`);
    return null;
  }

  const baseStyles = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: onClick ? 'pointer' : 'default',
    ...style,
  };

  return (
    <span className={`icon-wrapper ${className}`} style={baseStyles} onClick={onClick}>
      <IconComponent size={size} color={color} strokeWidth={2} />
    </span>
  );
}

export default Icon;
